import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import Article from "../../entities/Article";
import { ArticleService } from "../../service/articleDelivery/ArticleService";
import ArticleCategory from "../../entities/productOrder/article/ArticleCategory";

class ArticleStore {

    public articles: Article[];
    public pagination: Pagination;
    public filter?: string;
    public categoryFilter?: ArticleCategory;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.articles = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            articles: observable,
            pagination: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.articles.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async clearFilter() {
        this.filter = undefined;
        this.categoryFilter = undefined;
        this.search();
    }

    @action
    public async search() {
        await this.getElements(1);
    }


    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await ArticleService.get(page, pageSize, this.filter, this.categoryFilter?.id);
        if (response.success) {
            runInAction(() => {
                this.articles = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default ArticleStore;